import {
  V2ListClientsForAccountApiArg,
  useV2ListClientsForAccountQuery,
} from "@generated";
import type { Client } from "../types";

export interface UseClientsListArgs {
  page?: V2ListClientsForAccountApiArg["page"];
  filter?: V2ListClientsForAccountApiArg["filter"];
  sort?: V2ListClientsForAccountApiArg["sort"];
}

export interface ClientsListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useClientsList = ({ page, filter, sort }: UseClientsListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListClientsForAccountQuery(
      {
        page,
        filter,
        sort,
        include: ["rate-table"],
      },
      // Refetch whenever the list remounts (e.g. returning from Edit) so saved
      // changes are reflected without a manual reload.
      { refetchOnMountOrArgChange: true }
    );

  const rows: Client[] = (data?.data ?? []).map((client) => ({
    id: String(client.id),
    name: client.attributes?.name ?? "",
    msaDate: client.attributes?.["msa-date"],
    domain: client.attributes?.domain,
    active: client.attributes?.active,
  }));

  const pageMeta: ClientsListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useClientsList;
